export default {
  name: 'accessible-tabs',
  data: () => ({
    tabItems: null,
    firstTab: null,
    lastTab: null
  }),
  computed: {
    scope() {
      return {
      }
    }
  },
  mounted() {
    this.setComponent()
    this.bindListeners()
  },
  beforeDestroy() {
    this.unbindListeners()
  },
  methods: {
    setComponent() {
      this.tabItems = this.$el.querySelectorAll('.filter-item')
      this.firstTab = this.tabItems[0]
      this.lastTab = this.tabItems[this.tabItems.length - 1]
    },
    bindListeners() {
      this.tabItems.forEach((tab) => {
        tab.addEventListener('keydown', this.handleNavigation)
        tab.addEventListener('focus', this.focusTab)
        tab.addEventListener('focusout', this.unfocusTab)
      })
    },
    handleNavigation(event) {
      if (event.code === 'ArrowRight') {
        if (event.currentTarget === this.lastTab) {
          this.firstTab.focus()
        } else {
          event.currentTarget.nextElementSibling.focus()
        }
      }
      if (event.code === 'ArrowLeft') {
        if (event.currentTarget === this.firstTab) {
          this.lastTab.focus()
        } else {
          event.currentTarget.previousElementSibling.focus()
        }
      }
    },
    focusTab(event) {
      event.currentTarget.classList.add('is-focused')
      event.currentTarget.click()
    },
    unfocusTab(event) {
      event.currentTarget.classList.remove('is-focused')
    },
    unbindListeners() {
      this.tabItems.forEach((tab) => {
        tab.removeEventListener('keydown', this.handleNavigation)
        tab.removeEventListener('focus', this.focusTab)
        tab.removeEventListener('focusout', this.unfocusTab)
      })
    },
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  }
}
